import 'UI/Widget/Base'
import './MenuForm'
import { InvalidArgumentError, RuntimeError } from '../../errors'

/** @namespace Glonass.UI */
NS('Glonass.UI')

/**
 * @class
 * @extends UI.Widget.Base
 */
Glonass.UI.Workspace = Class(UI.Widget.Base, /** @lends Glonass.UI.Workspace.prototype */ {
    template: 'Glonass/Workspace',

    menuFormClass: 'Glonass/UI/MenuForm',
    /** @type {Glonass.UI.MenuForm} */
    menuForm: null,
    dutyForm: null,

    $workspace: null,
    $duty: null,

    forms: {},

    items: {},

    initialize () {
        this.ParentCall()

        this.addItems()
    },

    destroy () {
        this.closeAll()
        return this.ParentCall()
    },

    closeAll (exclude = []) {
        _.each(this.forms, (form, name) => {
            if (!exclude.includes(name)) {
                form.destroy()
            }
        })

        if (!exclude.includes('admin.menu')) {
            this.menuForm && this.menuForm.destroy()
        }

        return this
    },

    addItems () {
        this.addItem('admin', () => import('./AdminForm'))

        return this
    },

    render () {
        this.ParentCall()

        this.$workspace = this.$name('workspace', true)

        this.showMenu()

        return this
    },

    async showMenu () {
        if (!this.menuForm) {
            if (this.menuFormClass) {
                this.menuForm = Util.create(this.menuFormClass, [this])
                    .render().appendTo(this.$workspace)
                    .on('menuItemClick', this.onMenuItemClick, this)
                    .on('destroy', () => {
                        this.menuForm = null
                    })
            }
        } else {
            this.menuForm.pop()
        }

        return this.menuForm
    },

    addItem (name, options = {}) {
        this.items[name] = {}

        if (typeof options === 'string') {
            this.items[name].form = options
        } else if (typeof options === 'function') {
            this.items[name].callback = options
        } else if (_.isPlainObject(options) && options.form) {
            this.items[name] = options
        } else {
            throw new InvalidArgumentError('Invalid `options` argument')
        }

        return this
    },

    async showItem (name, options) {
        let item = this.items[name]

        if (!item) {
            throw new RuntimeError('Unknown workspace item')
        }

        if (this.forms[name]) {
            this.forms[name].pop()
        } else {
            try {
                application.ui.spinnerStart()

                options = {
                    ..._.omit(item, 'callback'),
                    ...Util.object(options),
                }

                this.forms[name] = await this.loadItem(item.form || item.callback, options)
                this.forms[name].on('destroy', () => delete this.forms[name])

                await this.forms[name].render()
                this.forms[name].appendTo(this.$workspace)
            } finally {
                application.ui.spinnerStop()
            }
        }

        return this.forms[name]
    },

    /**
     * @param {Promise<Ctor>|function} classNameOrCallback
     * @param {Object} [options]
     * @return {Promise<UI.Widget.Base>}
     */
    async loadItem (classNameOrCallback, options) {
        let ctor
        if (_.isString(classNameOrCallback)) {
            ctor = _.get(global, classNameOrCallback)
        } else {
            ctor = classNameOrCallback()
        }

        const interopDefault = module => (module && module.default) || module

        let FormCtor = interopDefault(await ctor)
        if (typeof FormCtor !== 'function') {
            throw new RuntimeError('FormCtor is not a Function')
        }

        return new FormCtor(this, options)
    },

    onMenuItemClick (args) {
        this.showItem(args.name)
    },
})
